import script from "./NewsView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsView.vue?vue&type=script&setup=true&lang=js"

import "./NewsView.vue?vue&type=style&index=0&id=174329f2&scoped=true&lang=css"

import exportComponent from "C:\\fukunocha\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-174329f2"]])

export default __exports__